import { render, staticRenderFns } from "./messageBubble.vue?vue&type=template&id=0957d212&scoped=true"
import script from "./messageBubble.vue?vue&type=script&lang=js"
export * from "./messageBubble.vue?vue&type=script&lang=js"
import style0 from "./messageBubble.vue?vue&type=style&index=0&id=0957d212&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0957d212",
  null
  
)

export default component.exports